// Получаем данные webMaster из параметров url или telegram,
// в случе если клиент зашел через telegram бота, то возвращаем tgBot
export function getTelegramWebApp(): boolean {
  return (window as any)?.Telegram?.WebApp?.initData !== '';
}
